export const OPEN_IN_BROWSER = 'open_in_browser';

export const ERROR_SHOW = 'error_show';

export const ERROR_TEXT = 'error_text';